import React, { useState } from 'react';
import AssignSuccessPopup from './AssignSuccessPopup';

const AssignedToModal = ({ isOpen, onClose, onAssign }) => {
    const [assignToMe, setAssignToMe] = useState(false);
    const [assignTo, setAssignTo] = useState('');
    const [completedBy, setCompletedBy] = useState('');
    const [priority, setPriority] = useState('');
    const [comments, setComments] = useState('');
      const [showSuccess, setShowSuccess] = useState(false);

    if (!isOpen) return null; 
 

  
    const today = new Date();
    const tomorrow = new Date(today);
    tomorrow.setDate(today.getDate() + 1);
    const defaultCompletedBy = tomorrow.toISOString().split('T')[0]; 

    return (
        <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50">
            <div className="relative w-full max-w-lg mx-auto bg-white rounded-lg shadow-xl overflow-hidden animate-fade-in-up">
                {/* Modal Header */}
                <div className="flex items-center justify-between px-6 py-4 bg-gray-50 border-b border-gray-200">
                    <h2 className="text-lg font-semibold text-gray-800">Assigned To</h2>
                    <button
                        onClick={onClose}
                        className="text-gray-500 hover:text-gray-700 focus:outline-none text-2xl font-light"
                        aria-label="Close"
                    >
                        &times;
                    </button>
                </div>

                {/* Modal Body */}
                <div className="p-6">
                    {/* Assign to me checkbox */}
                    <div className="mb-6 flex items-center">
                        <input
                            type="checkbox"
                            id="assignToMe"
                            className="mr-3 h-4 w-4 text-blue-600 focus:ring-blue-500 border-gray-300 rounded"
                            checked={assignToMe}
                            onChange={(e) => setAssignToMe(e.target.checked)}
                        />
                        <label htmlFor="assignToMe" className="text-gray-700 font-medium select-none">
                            Assign to me
                        </label>
                    </div>

                    {/* Assign To field */}
                    <div className="mb-4">
                        <label htmlFor="assignTo" className="block text-gray-700 text-sm font-bold mb-2">
                            Assign To<span className="text-red-500">*</span>
                        </label>
                        <textarea
                            id="assignTo"
                            rows="4"
                            className="shadow-sm appearance-none border border-gray-500 rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none   min-h-[100px] resize-y"
                            placeholder="Enter assign to"
                            value={assignTo}
                            onChange={(e) => setAssignTo(e.target.value)}
                        ></textarea>
                    </div>

                    {/* Completed By and Priority */}
                    <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mb-4">
                        <div>
                            <label htmlFor="completedBy" className="block text-gray-700 text-sm font-bold mb-2">
                                Completed By
                            </label>
                            <input
                                type="date"
                                id="completedBy"
                                className="shadow-sm appearance-none border border-gray-500 rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:border-transparent"
                                value={completedBy || defaultCompletedBy} // Use default if not set
                                onChange={(e) => setCompletedBy(e.target.value)}
                            />
                        </div>
                        <div>
                            <label htmlFor="priority" className="block text-gray-700 text-sm font-bold mb-2">
                                Priority
                            </label>
                            <div className="relative">
                                <select
                                    id="priority"
                                    className="block appearance-none w-full bg-white border border-gray-500 text-gray-700 py-2 px-3 pr-8 rounded leading-tight focus:outline-none shadow-sm"
                                    value={priority}
                                    onChange={(e) => setPriority(e.target.value)}
                                >
                                    <option value="">Select priority</option>
                                    <option value="high">High</option>
                                    <option value="medium">Medium</option>
                                    <option value="low">Low</option>
                                </select>
                                <div className="pointer-events-none absolute inset-y-0 right-0 flex items-center px-2 text-gray-700">
                                    <svg className="fill-current h-4 w-4" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20">
                                        <path d="M9.293 12.95l.707.707L15.657 8l-1.414-1.414L10 10.828 5.757 6.586 4.343 8z" />
                                    </svg>
                                </div>
                            </div>
                        </div>
                    </div>

                    {/* Comments field */}
                    <div className="mb-6">
                        <label htmlFor="comments" className="block text-gray-700 text-sm font-bold mb-2">
                            Comments
                        </label>
                        <textarea
                            id="comments"
                            rows="4"
                            className="block appearance-none w-full bg-white border border-gray-500 text-gray-700 py-2 px-3 pr-8 rounded leading-tight focus:outline-none shadow-sm"
                            placeholder="write ...."
                            value={comments}
                            onChange={(e) => setComments(e.target.value)}
                        ></textarea>
                    </div>
                </div>

                {/* Modal Footer */}
                <div className="flex justify-end px-6 py-4 bg-gray-50 border-t border-gray-200">
                    <button
                    
   onClick={() => {
    onClose()
 
  }}
 
  
                        className="bg-blue-600 hover:bg-blue-700 border-gray-500 text-white font-bold py-2 px-6 rounded shadow-md transition duration-200 ease-in-out focus:outline-none "
                    >
                        Assign
                    </button>
                </div>
            </div>
          
        </div>
    );
};

export default AssignedToModal;